<template>
  <div>
    <div class="wrapper-x-40">
      <h1> {{ $t('admin.views.orders.title_list') }}</h1>
    </div>
    <div class="content">
      <div>
        <div>
          <div>
            <div class="mb-30 action-panel flex items-center wrapper-x-40">
              <div>
                <button
                  class="btn btn-small btn-red"
                  @click="
                    $store.dispatch('orders/remove', deletes);
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-times"></i></span>
                  <span class="ml-2">{{ $t('main.button_delete') }}</span>
                </button>
              </div>
            </div>

            <div
              class="element-list table-list-wrapper wrapper-x-40"
              v-if="orders"
            >
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        @change="changeCheck"
                      />
                    </th>
                    <th class="number">{{ $t('admin.views.orders.column_number') }}:</th>
                    <th class="date">{{ $t('admin.views.orders.column_date') }}:</th>
                    <th class="client">{{ $t('admin.views.orders.column_client') }}:</th>
                    <th class="phone">{{ $t('admin.views.orders.column_phone') }}:</th>
                    <th class="updated">{{ $t('admin.views.orders.column_updated') }}:</th>
                    <th class="download-to-pdf">{{ $t('admin.views.orders.column_download_pdf') }}:</th>
                    <th class="total-cost cost-value">{{ $t('admin.views.orders.column_total_cost') }}:</th>
                    <th class="total">{{ $t('admin.views.orders.column_cost') }}:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="order in orders"
                    :key="order.order_id"
                  >
                    <td>
                      <input
                        type="checkbox"
                        ref="checkDeletes"
                        :value="order.order_id"
                        v-model="deletes"
                      />
                    </td>
                    <td class="number">
                      <router-link
                        class="underline"
                        :to="{
                          name: 'order_detail',
                          params: {
                            order_id: order.order_id,
                          },
                        }"
                      >
                        {{ order.order_id }}
                      </router-link>
                    </td>
                    <td class="date">
                      {{ order.date }}
                    </td>
                    <td class="client">{{ order.name }}</td>
                    <td class="phone">{{ order.phone }}</td>
                    <td class="updated"><i
                        v-if="order.updated"
                        class="fa fa-check text-green-500"
                      ></i></td>
                    <td class="download-to-pdf">
                      <div class="flex gap-3">
                        <a
                          :href="`/generate-pdf/${order.order_id}`"
                          class="flex items-center"
                        >
                          <span
                            class="icon-download-pdf"
                            style="
                            background-image: url('/images/icons/icon-pdf.svg');
                          "
                          ></span>
                        </a>
                        <a
                          :href="`/generate-pdf/${order.order_id}?adv=1`"
                          class="flex items-center"
                        >
                          <span
                            class="icon-download-pdf"
                            style="
                            background-image: url('/images/icons/adv-pdf-admin.svg');
                          "
                          ></span>
                        </a>
                      </div>

                    </td>
                    <td class="total-cost cost-value">
                      {{ $toCurrency(parseFloat(order.total_cost) || 0) }}
                    </td>
                    <td class="total">
                      {{ $toCurrency(parseFloat(order.total)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <PaginationBar
                :meta="meta"
                :page="page"
                :per-page="per_page"
                :per-pages="perPages"
                @set-page="setPage"
                @set-per-page="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationBar from "../../../components/Admin/PaginationBar.vue";

export default {
  name: "List",
  components: { PaginationBar },
  data() {
    return {
      deletes: [],
    };
  },
  mounted() {
    if (!this.licensed) {
      this.$router.push({ name: "no_license" });
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    orders() {
      return this.$store.state.orders.orders;
    },
    meta() {
      return this.$store.state.orders.meta;
    },
    page() {
      return this.$store.state.orders.page;
    },
    per_page() {
      return this.$store.state.orders.per_page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    setPage(page) {
      this.$store.dispatch("orders/setPage", page);
    },

    setPerPage(event) {
      this.$store.dispatch(
        "orders/setPerPage",
        event.target && event.target.value ? event.target.value : event
      );
    },
    changeCheck(event) {
      this.deletes = [];
      if (event.target.checked) {
        this.$refs.checkDeletes.map((check) => {
          check.checked = true;
          this.deletes.push(check.value);
        });
      } else {
        this.$refs.checkDeletes.map((check) => (check.checked = false));
      }
    },
  },
};
</script>
<style scoped>
.updated {
  text-align: center;
}
th.total,
td.total {
  text-align: right;
}
</style>
